/**
 * iOS Safari Detection and PWA Mode Utilities
 * 
 * Detects iOS Safari browser vs PWA (Add to Home Screen) mode
 * and provides utilities to handle differences in behavior.
 */

export function isIOS(): boolean {
  if (typeof window === 'undefined') return false;
  
  return /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream;
}

export function isIOSSafari(): boolean {
  if (typeof window === 'undefined') return false;
  
  const ua = navigator.userAgent;
  const iOS = /iPad|iPhone|iPod/.test(ua) && !(window as any).MSStream;
  const webkit = /WebKit/.test(ua);
  const notChrome = !(/CriOS/.test(ua));
  const notFirefox = !(/FxiOS/.test(ua));
  
  return iOS && webkit && notChrome && notFirefox;
}

export function isIOSPWA(): boolean {
  if (typeof window === 'undefined') return false;
  
  // Check if running in standalone mode (Add to Home Screen)
  return (
    isIOS() &&
    (window.navigator as any).standalone === true
  );
}

export function isIOSBrowser(): boolean {
  // iOS Safari in browser mode (not PWA)
  return isIOSSafari() && !isIOSPWA();
}

/**
 * Get iOS mode for debugging
 */
export function getIOSMode(): 'pwa' | 'browser' | 'not-ios' {
  if (!isIOS()) return 'not-ios';
  if (isIOSPWA()) return 'pwa';
  return 'browser';
}

/**
 * Check if we should use workarounds for iOS browser mode
 */
export function needsIOSBrowserWorkaround(): boolean {
  return isIOSBrowser();
}
